import { Communication } from '../redux/ducks'

const communicationWasSuccessful = (
  { success: lastSuccess }: Communication,
  { success }: Communication,
) => !lastSuccess && success

export default communicationWasSuccessful



// WEBPACK FOOTER //
// ./src/project-utils/communication-was-successful.ts